import * as realAlgoliaMapper from '../../algolia/mapper';
export class AlgoliaMockMapper {
    isValidResponse(rawData) {
        return rawData.hits && typeof rawData.nbHits !== 'undefined';
    }
    mapProducts(rawProducts) {
        // Direct reuse of real Algolia mapper
        return realAlgoliaMapper.mapProducts(rawProducts);
    }
    mapFilters(facets, currentFilters) {
        // Direct reuse of real Algolia mapper
        // The real mapper expects facets and facetsStats as separate params
        return realAlgoliaMapper.mapFilters(facets, undefined, currentFilters);
    }
    mapMeta(rawData, page, pageSize) {
        // Direct reuse of real Algolia mapper
        return realAlgoliaMapper.mapMeta(rawData);
    }
}
